import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Fab, Tooltip, Zoom } from '@mui/material';
import { HelpOutline as HelpIcon } from '@mui/icons-material';
import { useSettings } from '../context/SettingsContext';

const FloatingHelpButton = () => {
  const navigate = useNavigate();
  const { settings } = useSettings();
  const [hover, setHover] = useState(false);

  return (
    <Zoom in>
      <Tooltip title="Raise a Support Ticket" placement="left">
        <Fab
          onClick={() => navigate('/support')}
          onMouseEnter={() => setHover(true)}
          onMouseLeave={() => setHover(false)}
          sx={{
            position: 'fixed',
            bottom: 32,
            right: 32,
            bgcolor: settings?.primaryColor || '#64A8ED',
            color: 'white',
            zIndex: 1300,
            boxShadow: hover
              ? '0 8px 24px rgba(0,0,0,0.25)'
              : '0 4px 12px rgba(0,0,0,0.15)',
            transform: hover ? 'scale(1.08)' : 'scale(1)',
            transition: 'all 0.2s ease',
            '&:hover': {
              bgcolor: settings?.primaryColor || '#64A8ED',
              filter: 'brightness(0.9)'
            }
          }}
        >
          <HelpIcon />
        </Fab>
      </Tooltip>
    </Zoom>
  );
};

export default FloatingHelpButton;
